module.exports = __webpack_public_path__ + "static/media/platform-step1-desktop.2e00aa0a.png";